export const terms = [
  {
    title: "User Obligations",
    description:
      "As a User, you are obligated to provide accurate and up-to-date information during the registration process. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. Furthermore, you agree to use our platform in compliance with all applicable laws and regulations. ",
  },
  {
    title: "Service Description",
    description:
      "TRADEFOLIO is a platform that facilitates automated trade execution for Users who connect their brokers. It’s important to note that TRADEFOLIO does not provide brokerage services directly. Users must have an active account with a third-party broker to utilize our services effectively.",
  },
  {
    title: "Fees",
    description:
      "TRADEFOLIO may impose fees for the use of our services. Any applicable fees will be clearly communicated to Users, and you agree to pay these fees as stipulated. Failure to pay fees may result in the suspension or termination of your access to the platform. ",
  },
  {
    title: "Risks",
    description:
      "rading involves inherent risks, and past performance is not necessarily indicative of future results. Users acknowledge and agree that they bear sole responsibility for their investment decisions. TRADEFOLIO is not liable for any losses incurred while using our platform or services.",
  },
  {
    title: "Limitation of Liability ",
    description:
      "TRADEFOLIO shall not be held liable for any losses or damages, including but not limited to financial losses, arising from the use of our platform or services. This limitation of liability applies to all claims, whether based on warranty, contract, tort, or any other legal theory. ",
  },
  {
    title: "Termination",
    description:
      "TRADEFOLIO reserves the right to suspend or terminate a User’s access to the platform for any reason, including, but not limited to, violation of these terms, suspected fraud, or illegal activities. In the event of termination, Users shall no longer have access to their account or any associated data.",
  },
  {
    title: "Intellectual Property ",
    description:
      "All content and materials on the TRADEFOLIO platform, including but not limited to text, graphics, logos, and software, are protected by intellectual property laws. You may not use, reproduce, or distribute any content from our platform without our written consent.",
  },
  {
    title: "Privacy ",
    description:
      "TRADEFOLIO is committed to protecting the privacy of our Users. We collect and use personal information in accordance with our Privacy Policy. By using our platform, you consent to our data practices as outlined in the Privacy Policy. ",
  },
  {
    title: "Governing Law ",
    description:
      "This Agreement shall be governed by and construed in accordance with the laws of [Jurisdiction]. Any disputes arising from this Agreement shall be subject to the exclusive jurisdiction of the courts in [Jurisdiction].",
  },
  {
    title: "Changes to Terms",
    description:
      "TRADEFOLIO reserves the right to update or modify these terms at any time. Users will be notified of any changes, and continued use of our platform after such modifications constitutes acceptance of the revised terms.",
  },
];

export const privacy = [
  {
    title: "Information We Collect",
    subtitle:
      "We may collect various types of personal information to provide and improve our services. This includes, but is not limited to: ",
    bullets: [
      "Contact Information: This may include your name, email address, phone number, and postal address. This information allows us to communicate with you, provide support, and send important updates. ",
      "Account Information: When you create an account with us, we collect information such as usernames, passwords, and other security- related data. This information is used for authentication and account access. ",
      "Financial Information: In order to execute trades on your behalf, we may collect and process details related to your brokerage accounts, including account numbers, transaction history, and balances. ",
      "Usage Data: We gather information about your interactions with our platform. This includes pages visited, features used, time spent on each page, and other actions taken within the platform. This data helps us understand how you use TradeFolio and enables us to enhance your experience.",
      "Device Information: We collect information about the device you use to access our platform. This may include your IP address, browser type, operating system, and device identifiers. This information helps us optimize the platform for different devices and troubleshoot technical issues. ",
    ],
  },
  {
    title: "How We Use Your Information ",
    subtitle:
      "We may use your personal information for the following purposes: ",
    bullets: [
      "Providing and Improving Services: Your information enables us to deliver our services, including trade execution and account management. It also helps us enhance the functionality and features of our platform. ",
      "Communications: We may use your contact information to send you important updates, account notifications, and promotional materials. You have the option to opt out of promotional communications. ",
      "Analytics and Research: We analyze usage patterns and trends to gain insights into how our platform is used. This information helps us make data-driven decisions to improve our services. ",
    ],
  },
  {
    title: "Sharing of Information ",
    subtitle:
      "We do not sell or rent your personal information to third parties. However, we may share your information with:",
    bullets: [
      "Third-party Service Providers: We may engage trusted third-party service providers to assist us in delivering and maintaining our services. These providers may have access to your personal information but are bound by confidentiality agreements.",
      "Regulatory Authorities and Law Enforcement: In certain situations, we may be required to disclose your information to comply with legal obligations or respond to lawful requests from regulatory authorities or law enforcement agencies. ",
      "Affiliates and Partners: We may collaborate with affiliated companies or partners to offer specific features or promotions. In such cases, your information may be shared in a manner consistent with this Privacy Policy.",
    ],
  },
  {
    title: "Security Measures",
    subtitle:
      "We employ industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction. These measures include encryption, access controls, and regular security assessments. However, please be aware that no method of transmission over the internet or electronic storage is completely secure.",
    bullets: [],
  },
  {
    title: "Your Choices",
    subtitle: "You have the right to: ",
    bullets: [
      "Access, Correct, or Update Information: You can access, review, correct, or update your personal information through your account settings. ",
      "Opt Out of Promotional Communications: You can choose to opt out of receiving promotional communications from us by following the instructions provided in the communication. ",
      "Close Your Account: If you no longer wish to use our services, you can request to close your account. Upon closure, your personal information will be deleted in accordance with our data retention policies. ",
    ],
  },
  {
    title: "Children’s Privacy",
    subtitle:
      "Our platform is not directed towards children under the age of 13. We do not knowingly collect personal information from children. If you believe that we have inadvertently collected information from a child, please contact us promptly to request its deletion. ",
    bullets: [],
  },
  {
    title: "Changes to this Privacy Policy ",
    subtitle:
      "We may update this Privacy Policy from time to time to reflect changes in our practices and services. Any changes will be posted on this page with an updated effective date. We encourage you to review this Privacy Policy periodically. ",
    bullets: [],
  },
  {
    title: "Contact Us ",
    subtitle:
      "If you have any questions or concerns about this Privacy Policy, or if you need assistance regarding your personal information, please contact us at contact@TRADEFOLIO.com.",
    bullets: [],
  },
];

export const BLOG_CATEGORY = [
  {
    label: "None",
    value: "",
  },
  {
    label: "Business",
    value: "Business",
  },
  {
    label: "Health",
    value: "Health",
  },
];

export const ALGO_STATUS = {
  Publish: "Publish",
  Draft: "Draft",
  Private: "Private",
};

export const Bucket_Uri = `https://pxquoyexibwwbzitcljc.supabase.co/storage/v1/object/public/images`;
